import React from 'react'
import { Verification } from 'src/features/otp'

const VerificationPage: React.FC = () => {
  return <Verification />
}

export default VerificationPage
